module.exports = __webpack_public_path__ + "img/335.bab145e3.jpg";